import { ColorswatchFacetDisplayValue } from "./colorswatchFacet.container";
import { ColorswatchFacetValueComponent } from "./colorswatchFacetValue.component";

type ColorswatchFacetComponentProps = {
    values: Array<ColorswatchFacetDisplayValue>;
};

const ColorswatchFacetComponent = ({
    values
}: ColorswatchFacetComponentProps) => {
    return (
        <ul
            className={
                "tw:-translate-0.75 tw:pt-3 tw:flex tw:flex-wrap tw:relative tw:mb-0"
            }
        >
            {values.map((value) => (
                <ColorswatchFacetValueComponent
                    key={`${value.label}-${value.refined}`}
                    value={value}
                />
            ))}
        </ul>
    );
};

export { ColorswatchFacetComponent };
